export default "__VITE_PUBLIC_ASSET__e4409bf9__"